import { KeyValuePair } from "./KeyValuePair";

export interface FilterDto {
    name: string;
    description: string;
    type: FilterType;
    values?: KeyValuePair[];
    formatValue?: (value: string) => string;
    staticValueLabel?: string
}

export enum FilterType {
  TEXT,
  DATE,
  SELECT,
  MULTIPLE,
  MULTIPLE_TREE
}